import { Box, Button, ButtonAppearance, ButtonSize, SideSheet } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const SearchSectionStyled = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[200]};
`;

export const SearchButtonListAreaStyled = styled(Box)`
  gap: ${({ theme }) => theme.spacings[300]};
`;

export const CreateReservationSideSheetStyled = styled(SideSheet)`
  width: calc(100vw - ${({ theme }) => theme.componentStyles.navBarWidth});
`;
export const ToolCatalogHeaderStyled = styled(Box)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[500]};
    padding: ${theme.spacings[500]};
    font-weight: ${theme.fontWeights[600]};
    background-color: ${({ theme }) => theme.colors.grey['100']};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    border-left: 1px solid ${theme.colors.grey[300]};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  `};
`;

export const SearchSectionButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.SECONDARY,
  size: ButtonSize.MEDIUM,
})`
  width: auto;
  outline: none;
  &:focus {
    box-shadow: none;
  }
`;

export const ToolCartButtonAreaStyled = styled.div`
  ${({ theme }) => css`
    border-left: 1px solid ${theme.colors.grey[300]};
    background-color: ${theme.colors.grey['100']};
    position: relative;
  `};
`;

export const ToolCountStyled = styled.div`
  position: absolute;
  ${({ theme }) => css`
    height: 20px;
    width: 20px;
    border-radius: ${theme.radii[900]};
    background-color: ${theme.colors.bechtel.red};
    right: 12px;
    top: 4px;
    text-align: center;
  `}
`;

export const ToolCategoryIcon = styled.i`
  ${({ theme }) => css`
    color: ${theme.colors.blue[800]};
    font-size: ${theme.fontSizes[800]};
  `}
`;
